/* AKTEPELER - gorunume girme gozlemcisi.
 *
 * window.addEventListener('scroll') KULLANILMAZ: her kaydirma karesinde
 * calisir, batch'lenmez, mobilde kare dusurur. IntersectionObserver tarayici
 * tarafindan batch'lenir ve ana is parcacigini mesgul etmez.
 *
 * Animasyonun kendisi CSS'te (aktepeler-hareket.css). Bu dosya yalniz
 * "gorundu" isaretini koyar; boylece animasyon ana is parcacigi disinda,
 * derleyici katmaninda calisir.
 *
 * Her oge BIR KEZ oynar. Ogeyi gorduk mu, gozlemden cikariyoruz - her
 * kaydirmada tekrar oynayan animasyon kisa surede rahatsiz edici olur.
 */
(function () {
  'use strict';

  document.documentElement.classList.remove('no-js');

  var hedefler = [
    '.product-card',
    '.akt-slide',
    '.akt-kolban__ic',
    '.akt-hub__kart',
    '.akt-alt__sutun'
  ].join(',');

  function kur() {
    // Azaltilmis hareket: hicbir sey isaretlenmez, CSS zaten gorunur birakir.
    var az = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var ogeler = document.querySelectorAll(hedefler);
    if (!ogeler.length) return;

    // IntersectionObserver yoksa (cok eski tarayici) icerik gizli kalmasin.
    if (!('IntersectionObserver' in window) || az) {
      for (var i = 0; i < ogeler.length; i++) {
        ogeler[i].setAttribute('data-akt-gir', '');
        ogeler[i].setAttribute('data-akt-gorundu', '');
      }
      return;
    }

    // Horizon html/body'yi overflow:hidden yapip sayfayi .page-wrapper icinde
    // kaydiriyor (olculdu: body 720px, .page-wrapper scrollHeight 3624px).
    // root:null da calisir ama kaydiriciyi acikca vermek daha saglam:
    // tema ileride yapiyi degistirirse gozlemci sessizce bozulmaz.
    var kaydirici = document.querySelector('.page-wrapper');
    if (kaydirici && kaydirici.scrollHeight <= kaydirici.clientHeight) kaydirici = null;

    var gozlemci = new IntersectionObserver(function (girisler, gozcu) {
      // Ayni anda gorunen ogeleri sirala, sonra kademe gecikmesi ver.
      var gorunen = [];
      for (var i = 0; i < girisler.length; i++) {
        if (girisler[i].isIntersecting) gorunen.push(girisler[i].target);
      }
      gorunen.sort(function (a, b) {
        return a.getBoundingClientRect().top - b.getBoundingClientRect().top;
      });

      for (var j = 0; j < gorunen.length; j++) {
        // 60 ms kademe: 30-80 ms araligi dogal hissettirir. Ustu yavas.
        // En fazla 4 oge gecikir; 5. ogeden sonra bekleme fark ediliyor.
        var gecikme = Math.min(j, 4) * 60;
        gorunen[j].style.setProperty('--akt-gecikme', gecikme + 'ms');
        gorunen[j].setAttribute('data-akt-gorundu', '');
        gozcu.unobserve(gorunen[j]);
      }
    }, {
      root: kaydirici,
      // Oge ekranin altindan 12% iceri girdiginde basla; tam kenarda
      // baslarsa kullanici animasyonun yarisini kaciriyor.
      rootMargin: '0px 0px -12% 0px',
      threshold: 0.01
    });

    for (var k = 0; k < ogeler.length; k++) {
      var o = ogeler[k];
      // Ilk ekranda zaten gorunen ogeye giris animasyonu verme; sayfa
      // acilir acilmaz alt alta seyler kayarsa hata gibi gorunur.
      var kutu = o.getBoundingClientRect();
      if (kutu.top < window.innerHeight * 0.9) continue;
      o.setAttribute('data-akt-gir', '');
      gozlemci.observe(o);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', kur, { once: true });
  } else {
    kur();
  }
})();
